import ApiUtil from './api';

class Api extends ApiUtil {
  getReputation() {
    return this.get('/reputation');
  }
  
  getUserReputation(userId) { 
    return this.get(`/api/v2/reputation/${userId}`);
  }

  getVotingStatus(userId) {
    return this.get(`/api/v2/reputation/${userId}/voting-status`);
  }

  voteReputation(data) {
    return this.post('/api/v2/reputation/vote', { data: JSON.stringify(data) });
  }
}

export default new Api();
